const requestIdleCallbackFallback = handler => {
  let startTime = Date.now();
  let interval = setTimeout(function() {
    handler({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50.0 - (Date.now() - startTime));
      }
    });
    clearTimeout(interval);
    interval = null;
  }, 1000);
  return interval;
};

const cancelIdleCallbackFallback = id => {
  clearTimeout(id);
};

const CSR_SUPPORT = typeof window === 'object';

export { version } from '../package.json';

export const supported =
  CSR_SUPPORT && typeof window.requestIdleCallback === 'function';

export const queue = callback => {
  if (!CSR_SUPPORT) {
    return;
  }

  return window.requestIdleCallback(callback);
};

if (CSR_SUPPORT && !supported) {
  window.requestIdleCallback = requestIdleCallbackFallback;
  window.cancelIdleCallback = cancelIdleCallbackFallback;
}
